import React from "react";
import { Link } from "react-router-dom";
import { useStateValue } from "../../StateProvider";

function Header() {
  const [{ basket }] = useStateValue();

  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-light">
      <Link className="navbar-brand" to="/">
        Samstagsbrötchen
      </Link>
      <button
        className="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span className="navbar-toggler-icon"></span>
      </button>

      <div className="collapse navbar-collapse" id="navbarSupportedContent">
        <ul className="navbar-nav mr-auto">
          <li className="nav-item">
            <Link to="/" className="nav-link">
              Startseite
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/products" className="nav-link">
              Angebot
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/contact" className="nav-link">
              Kontakt
            </Link>
          </li>
        </ul>
        <form className="form-inline my-2 my-lg-0">
          <Link
            to="/basket"
            className="btn btn-outline-success my-2 my-sm-0 mr-2"
          >
            <i className="fas fa-shopping-basket mr-1"></i>
            Warenkorb {basket?.length}
          </Link>
          <Link to="/account" className="btn btn-outline-success my-2 my-sm-0">
            Konto
          </Link>
        </form>
      </div>
    </nav>
  );
}

export default Header;
